import { MomentInput } from 'moment';

import { Pipe, PipeTransform } from '@angular/core';

import { Session } from '@services/session';

import { moment } from '@lib/moment';

@Pipe({ name: 'dateRange' })
export class DateRangePipe implements PipeTransform {
  public static TIME_RANGE_FORMAT: string = 'h:mm A';

  private readonly userTimezone: string;

  constructor( session: Session ) {
    this.userTimezone = session.getUserTimeZone();
  }

  public transform(
    { start, end }: {
      start: MomentInput;
      end?: MomentInput;
    },
    format: string = DateRangePipe.TIME_RANGE_FORMAT,
    timezone: string = this.userTimezone,
  ): string {
    if (!format) format = DateRangePipe.TIME_RANGE_FORMAT;

    const startDateTime = moment(start).mapTz(timezone).format(format);
    if (end) {
      const endDateTime = moment(end).mapTz(timezone).format(format);
      return `${startDateTime} – ${endDateTime}`;
    } else {
      return `${startDateTime} – `;
    }
  }
}
